module.exports = __webpack_public_path__ + "static/effaaad4-a81a-48c6-94de-b9f8c438ce11-51633212660af14feffd79e48dfb8c78.webp";